// GLOBAL
export const globalBackground = '#E5E5E5'

// COLORS
export const primary = '#00A9EB'
export const primary300 = '#63E3F9'
export const primary700 = '#0062A9'
export const primary100 = '#CBFDFE'
export const secondary = '#727CF5'
export const secondary100 = '#E3E6FE'
export const secondary300 = '#ABB2FC'
export const tertiary = '#2A3E60'

// TODO: Add focus border color later
// // FOCUS_BORDER_COLOR
// export const focusBorderColorPrimary = 'rgba(49, 151, 149, 0.6)'

// BREAKPOINTS
// INFO: Our breakpoints (576px, 767.98px, 1200px, 1440px)
export const breakPointValues = {
  base: '0px',
  sm: '575px',
  md: '767px',
  lg: '1119px',
  xl: '1439px'
}
